import { render } from "./layout.vue?vue&type=template&id=736f7e5a&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"

import "./layout.vue?vue&type=style&index=0&id=736f7e5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-736f7e5a"

export default script